export default {
  // 主题基本信息
  code: 'chem-video',
  name: '2026年全国大学生化工短视频大赛',
  description: '化工短视频作品征集与展示平台',
  
  // 路由配置
  routeBase: '/chem-video',
  
  // 主题路由定义
  routes: [
    { path: '', component: 'Promo', meta: { title: '首页' } },
    { path: 'gallery', component: 'Gallery', meta: { title: '作品展示' } },
    { path: 'work-submit', component: 'WorkSubmit', meta: { title: '提交作品' }, auth: true },
    { path: 'work/detail/:id', component: 'WorkDetail', meta: { title: '作品详情' } },
    { path: 'user/center', component: 'UserCenter', meta: { title: '个人中心' }, auth: true },
    { path: 'my-works', component: 'MyWorks', meta: { title: '我的作品' }, auth: true },
    { path: 'login', component: 'Login', meta: { title: '登录' } },
    { path: 'register', component: 'Register', meta: { title: '注册' } }
  ],
  
  // 主题样式 - 化工蓝为主色调
  themeColor: '#0066cc',
  secondaryColor: '#ff6b35',
  
  // API配置
  apiPrefix: '/portal',
  
  // 扩展配置
  extra: {
    organization: '中国化工学会',
    location: '华侨大学',
    year: 2026,
    contactEmail: '35618@hqu.edu.cn',
    contactPhone: '0592-6167376',
    qqGroup: '1079228422'
  }
}
